import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

onDocumentReady(
  function dispatchPageViewEvent() {
    // Collection and product pages are prerendered on hover (see the
    // speculationrules block in theme.liquid), which runs this script while the
    // document is still hidden. Firing here would count a page view for a page
    // the visitor only hovered, so defer until the prerender is activated.
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', dispatchPageViewEvent, { once: true });
      return;
    }

    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);
